module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .spl-form__page__settings .table > div > div {\n        padding : 5px 10px;\n    }\n\n    .spl-form__page__settings .columns {\n        table-layout : fixed;\n    }\n\n    .spl-form__page__settings .columns .title {\n        width: 25%;\n    }\n\n    .spl-form__page__settings .columns .column-row > div {\n        width         : 25%;\n        overflow      : hidden;\n        text-overflow : ellipsis;\n    }\n</style>\n\n<div class=\"form__page spl-form__page spl-form__page__settings\">\n    <div>\n        <div class=\"table w100\">\n            <div>\n                <div class=\"title\">Кол-во строк</div>\n                <div>")
    ; __append(escapeFn( widget.options.meta.count ))
    ; __append("</div>\n            </div>\n            <div>\n                <div class=\"title\">Тип геометрии</div>\n                <div>")
    ; __append(escapeFn( widget.options.meta.geometryType ))
    ; __append("</div>\n            </div>\n            <div>\n                <div class=\"title\">Проекция</div>\n                <div>\n                    <control type=\"data-autocomplete\" target=\"options.projectionname\" source=\"GIS.Data.Projections\"\n                             column=\"name\" columns=\"name\" bind=\"options.projection:code\" strict=\"true\"/>\n                </div>\n            </div>\n\n            <div>\n                <div>\n                    <control type=\"checkbox\" target=\"options.clearlayer\" value=\"true\"/>\n                </div>\n                <div>\n                    Очистить слой перед импортом\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}